(() => {
  const cleanups = new WeakMap();
  const setup = (section) => {
    if (cleanups.has(section)) return;

    const track = section.querySelector('[data-stories-track]');
    const previous = section.querySelector('[data-stories-previous]');
    const next = section.querySelector('[data-stories-next]');
    if (!track || !previous || !next) return;
    const events = new AbortController();
    let frame;
    let inView = false;

    const update = () => {
      frame = undefined;
      if (!inView || !section.isConnected) return;
      const max = track.scrollWidth - track.clientWidth;
      const left = track.scrollLeft;
      previous.disabled = left <= 2;
      next.disabled = left >= max - 2;
    };
    const schedule = () => {
      if (inView && frame === undefined) frame = requestAnimationFrame(update);
    };
    const move = (direction) => {
      const card = track.querySelector('.salee-story');
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1), { signal: events.signal });
    next.addEventListener('click', () => move(1), { signal: events.signal });
    track.addEventListener('scroll', schedule, { passive: true, signal: events.signal });
    const resize = new ResizeObserver(schedule);
    resize.observe(track);
    const visibility = new IntersectionObserver(([entry]) => {
      inView = entry.isIntersecting;
      schedule();
    }, { rootMargin: '150px' });
    visibility.observe(section);
    cleanups.set(section, () => {
      events.abort();
      resize.disconnect();
      visibility.disconnect();
      cancelAnimationFrame(frame);
      cleanups.delete(section);
    });
  };

  document.querySelectorAll('[data-stories-section]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('[data-stories-section]');
    if (section) setup(section);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('[data-stories-section]').forEach((section) => cleanups.get(section)?.());
  });
})();
